import { render, staticRenderFns } from "./taskComment.vue?vue&type=template&id=b7eafdca&scoped=true&"
import script from "./taskComment.vue?vue&type=script&lang=js&"
export * from "./taskComment.vue?vue&type=script&lang=js&"
import style0 from "./taskComment.vue?vue&type=style&index=0&id=b7eafdca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eafdca",
  null
  
)

export default component.exports